module.exports = __webpack_public_path__ + "img/cce949e.jpg";